// utils/clearClientCache.js
//
// Wipes ALL client-side cached data (localStorage + sessionStorage) so that no user-specific
// information (profile, pickup/drop locations, allocated carriers, sidebar pins/recents, permission
// snapshots, cached order drafts, etc.) can leak across accounts on logout or when a different user
// logs in on the same browser.
//
// Only non-user, app-level keys are preserved (currently just branding `source`, so the correct
// branded login screen still renders after logout).

const PRESERVE_KEYS = ['source'];

export function clearClientCache() {
  try {
    const keep = {};
    for (const key of PRESERVE_KEYS) {
      const value = localStorage.getItem(key);
      if (value != null) keep[key] = value;
    }
    localStorage.clear();
    for (const [key, value] of Object.entries(keep)) {
      try { localStorage.setItem(key, value); } catch (_) { /* storage may be full/unavailable */ }
    }
  } catch (_) { /* localStorage unavailable */ }

  try {
    sessionStorage.clear();
  } catch (_) { /* sessionStorage unavailable */ }
}

export default clearClientCache;
